import { computed, makeObservable } from "mobx";
import {storageService} from "../services/storageService";
import { DateUtils } from "../helpers/dateUtils";

export class AppState{

    constructor() {
        makeObservable(this, {
            isAuthenticated: computed
        })        
    }

    get isAuthenticated() : boolean {
        const tokenData = storageService.getTokenData();
        if(tokenData){
            return DateUtils.isNotExpired(tokenData.refreshTokenExpiration);
        }
        return false;
    }
}

export const appState = new AppState();
